import { piiPresent, disableGA } from "./synchronous/disable_ga_on_pii";

$(() => {
  if (piiPresent()) { disableGA(); }
});
